export default __webpack_public_path__ + "static/media/article2.4e0fee23.jpg";